export const VALORACION_MIN = 1;
export const VALORACION_MAX = 5;
export const OBSERVACION_MAX_LENGTH = 500;

export const ESTADO_PAGINA = {
  CARGANDO: 'cargando',
  INVALIDO: 'invalido',
  ERROR: 'error',
  PENDIENTE: 'pendiente',
  CALIFICADO: 'calificado',
};

// Textos exactos que devuelve el back (Iosper\System\Exception\TurneroWarningMessage /
// AuthException::TOKEN_INVALIDO) dentro de `error.response.data.error`. La API no expone
// un código de error machine-readable para estos casos, solo el mensaje de texto.
export const MENSAJE_TURNO_YA_CALIFICADO = 'Este turno ya fue calificado';
export const MENSAJE_TOKEN_INVALIDO = 'El código de seguridad no es válido o ha caducado';
export const MENSAJE_TURNO_INEXISTENTE = 'El turno indicado no existe';
